import Vue from 'vue';
import App from './App.vue';
import router from './router';
// import vueSmoothScroll from 'vue-smooth-scroll';
import intersectionObserver from 'intersection-observer';
// import cssVars from 'css-vars-ponyfill';
import SocialSharing from 'vue-social-sharing';
import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.use(SocialSharing);

Vue.config.productionTip = false;
// Vue.use(vueSmoothScroll);

new Vue({
	router,
	// vueSmoothScroll,
	intersectionObserver,
	// SocialSharing,
	// cssVars,
	created(){
		AOS.init({
			once: true,
			duration: 1200
		})
	},
	render: (h) => h(App),
}).$mount('#app');
